import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initAnalytics } from './analytics/segment'
import { installErrorTracking } from './analytics/nativeAnalytics'

// Before the first render, so the error net catches failures during mount. `initAnalytics` is a
// silent no-op without VITE_SEGMENT_WRITE_KEY; the error net feeds every sink that IS live.
initAnalytics()
installErrorTracking()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
